var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingColumnsSolid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5962 3.1575C12.2288 2.9475 11.775 2.9475 11.4037 3.1575L3.00375 7.9575C2.53125 8.2275 2.29875 8.7825 2.4375 9.3075C2.57625 9.8325 3.05625 10.2 3.6 10.2H4.8V18L2.88 19.44C2.57625 19.665 2.4 20.0212 2.4 20.4C2.4 21.0638 2.93625 21.6 3.6 21.6H20.4C21.0638 21.6 21.6 21.0638 21.6 20.4C21.6 20.0212 21.4237 19.665 21.12 19.44L19.2 18V10.2H20.4C20.9438 10.2 21.42 9.8325 21.5588 9.3075C21.6975 8.7825 21.465 8.2275 20.9925 7.9575L12.5925 3.1575H12.5962ZM17.4 10.2V18H15V10.2H17.4ZM13.2 10.2V18H10.8V10.2H13.2ZM9 10.2V18H6.6V10.2H9ZM12 6C12.6637 6 13.2 6.53625 13.2 7.2C13.2 7.86375 12.6637 8.4 12 8.4C11.3363 8.4 10.8 7.86375 10.8 7.2C10.8 6.53625 11.3363 6 12 6Z",
    fill: "#F4FDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingColumnsSolid2);
export default __webpack_public_path__ + "static/media/building-columns-solid-2.bc11379f7c2a46078c97c824a0ae6d0a.svg";
export { ForwardRef as ReactComponent };